import { Image } from '../../../shared/shared.interface';

export interface KngStatusSelector {
    state: KngStatusSelectorState;
}
export interface KngStatusSelectorState {
    header: string;
    selectedStatus: string;
    count: Count[];
}

export interface Count {
    header: string;
    label: string;
    amount: number;
    icon?: Image;
}

export interface KngSelectionData {
    selectedStatus : string;
}


